import { render } from "./Detail.vue?vue&type=template&id=e07e7c44&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=e07e7c44&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e07e7c44"

export default script